import { ModalInfoTemplateProps } from './';

const template: ModalInfoTemplateProps = {
  ariaLabel: 'Form Submitted',
  renderHeader: () => <h2>Form Submitted</h2>,
  renderContent: () => <p>Lorem ipsum</p>,
};

export default template;
